import Vue from 'vue';
import VueRouter from 'vue-router';
import goTo from 'vuetify/es5/services/goto';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/auth/login'
  },
  /************************ CYC RUTAS ******************************/
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/CYC/autenticacion/views/LoginJob')
  },
  {
    path: '/eleccion',
    component: () => import(/* webpackChunkName: "eleccion" */ '@/CYC/comedor/votacion-empleado/views/VotacionEmpleado')
  },
  {
    path: '/campamento',
    component: () => import(/* webpackChunkName: "group-campamento" */ '@/layouts/full-layout/Layout'),
    children: [
      {
        name: 'campamento/asignacion',
        path: 'asignacion',
        component: () => import('@/CYC/campamento/asignacion/views/Asignacion')
      },
      {
        name: 'campamento/asignacion/asignar',
        path: 'asignacion/asignar',
        component: () => import('@/CYC/campamento/asignacion/components/AsignacionFormulario')
      },
      {
        name: 'campamento/asignacion/asignar_multiple',
        path: 'asignacion/asignar_multiple',
        component: () => import('@/CYC/campamento/asignacion/components/AsignacionMultiple')
      },
      {
        name: 'campamento/gestion',
        path: 'gestion',
        component: () => import('@/CYC/campamento/gestion/views/Gestion')
      },
      {
        name: 'campamento/dashboard',
        path: 'dashboard',
        component: () => import('@/CYC/dashboard/campamento/views/DashboardCampamento')
      },
      {
        name: 'campamento/reportes/asistencia',
        path: 'reportes/asistencia',
        component: () => import('@/CYC/campamento/reportes/asistencia/views/Asistencia')
      }
    ]
  },
  {
    path: '/comedor',
    component: () => import(/* webpackChunkName: "group-comedor" */ '@/layouts/full-layout/Layout'),
    children: [
      {
        name: 'comedor/asignacion',
        path: 'asignacion',
        component: () => import('@/CYC/comedor/asignacion/views/Asignacion')
      },
      {
        name: 'comedor/asignacion/asignar',
        path: 'asignacion/asignar',
        component: () => import('@/CYC/comedor/asignacion/components/AsignacionFormulario')
      },
      {
        name: 'comedor/gestion',
        path: 'gestion',
        component: () => import('@/CYC/comedor/gestion/views/Gestion')
      },
      {
        name: 'comedor/dashboard',
        path: 'dashboard',
        component: () => import('@/CYC/dashboard/comedor/views/DashboardComedor')
      },
      {
        name: 'comedor/gestion_plato/agregar',
        path: 'gestion_plato/agregar',
        component: () => import('@/CYC/comedor/gestionplato/components/GestionPlatoFormulario')
      },
      {
        name: 'comedor/gestion_plato',
        path: 'gestion_plato',
        component: () => import('@/CYC/comedor/gestionplato/views/GestionPlato')
      },
      {
        name: 'comedor/gestion_programacion_menu/agregar',
        path: 'gestion_programacion_menu/agregar',
        component: () => import('@/CYC/comedor/gestionprogramacionmenu/components/GestionProgramacionMenuFormulario')
      },
      {
        name: 'comedor/gestion_programacion_menu',
        path: 'gestion_programacion_menu',
        component: () => import('@/CYC/comedor/gestionprogramacionmenu/views/GestionProgramacionMenu')
      },
      {
        name: 'comedor/reportes/asistencia',
        path: 'reportes/asistencia',
        component: () => import('@/CYC/comedor/reportes/asistencia/views/Asistencia')
      }
    ]
  },
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "group-auth" */ '@/layouts/blank-layout/Blanklayout'),
    children: [
      {
        name: 'authlogin',
        path: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/CYC/autenticacion/views/Login')
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '*',
    component: () => import('@/views/authentication/Error')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  }
  // This is for the scroll top when click on any router link
});

export default router;
